<template>
<Dropdown trigger="click"  @visible-change="dropdownOpen = !dropdownOpen"
  :class="{ dropdownbutton: dropdownOpen }">
  <button type="primary" class="btn btn-secondary header_sbtn text-sm">
    {{ $t('ATTACHMENT_UPLOAD') }}
      <svgicon
      name="categorydropdown"
      class="dropdown-icon"
      width="10" height="10"
      :original="true"/>
  </button>
  <Dropdown-menu slot="dropdown">
    <Dropdown-item>
      <label>
        <input class="upload-material" type="file" id="file" ref="file"
          :accept="`${AttachmentConstants.excelMimes}`" v-on:change="bulkUpload" hidden/>
        <span class="action">Bulk Upload</span>
      </label>
      <a :href="`${$asset_path}static/sample/${sampleFileName}`"
        v-if="sampleFileName.length" download
        class="format-text"
        target="_blank">
        <span class="divided"></span>
        Sample format
      </a>
    </Dropdown-item>
  </Dropdown-menu>
</Dropdown>
</template>
<script>

import AttachmentConstants from '@common/constants/AttachmentConstants';

export default {
  props: {
    sampleFileName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      AttachmentConstants,
      dropdownOpen: false,
    };
  },
  methods: {
    bulkUpload() {
      const file = this.$refs.file.files[0];
      this.$emit('handleFileUpload', file);
    },
  },
};
</script>
